import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-redirect',
  templateUrl: './redirect.component.html',
  styleUrls: ['./redirect.component.css']
})
export class RedirectComponent implements OnInit {
  _id:number=0;
  
  constructor(
    private activatedRoute : ActivatedRoute,
    private router:Router,
    
  ){
    activatedRoute.params.subscribe( prm => {
    //  console.log(`El id es: ${prm['id']}`);
      this._id=prm['id'];
//alert();

    
  })
}

ngOnInit(): void {
    
this.router.navigate(['/pedido', this._id]);

}


}
